import { render, staticRenderFns } from "./DisplayElement.vue?vue&type=template&id=8649c5b4&scoped=true"
import script from "./DisplayElement.vue?vue&type=script&lang=js"
export * from "./DisplayElement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8649c5b4",
  null
  
)

export default component.exports